/**
 * Facility Type options for Contract Manufacturer profile (Factory Details).
 * Single-select dropdown options.
 */
export const FACILITY_TYPE_OPTIONS = [
  'Job Work / Subcontracting Facility',
  'Assembly Unit',
  'Prototype / R&D Facility',
  'Pilot Production Facility',
  'Mass Production Facility',
  'Clean Room / Sterile Facility',
  'Temperature-Controlled Facility',
  'Packaging Unit',
  'Testing & Quality Lab',
  'Tooling / Moulding Facility',
  '3D Printing / Additive Manufacturing',
  'Warehouse & Dispatch Facility',
];

/** Dropdown map: array of { value, label } */
export const FACILITY_TYPE_MAP = FACILITY_TYPE_OPTIONS.map((label) => ({
  value: label,
  label,
}));

export default FACILITY_TYPE_OPTIONS;
